import axios from "axios";

// Set the Authorization header globally
const token = localStorage.getItem("jwt_token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default axios;